import { render } from "./SurveyPopup.vue?vue&type=template&id=dc631286&scoped=true"
import script from "./SurveyPopup.vue?vue&type=script&lang=js"
export * from "./SurveyPopup.vue?vue&type=script&lang=js"

import "./SurveyPopup.vue?vue&type=style&index=0&id=dc631286&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc631286"]])

export default __exports__